import { ApiClient } from './api/client';
import { authMethods } from './api/auth';
import { vehiclesMethods } from './api/vehicles';
import { modificationsMethods } from './api/modifications';
import { imagesMethods } from './api/images';
import { performanceMethods } from './api/performance';
import { searchMethods } from './api/search';
import { profileMethods } from './api/profile';
import { importMethods } from './api/import';
import { adminMethods } from './api/admin';
import { adminEmailMethods } from './api/adminEmail';
import { sharingMethods } from './api/sharing';
import { analyticsMethods } from './api/analytics';
import { eventsMethods } from './api/events';
import { judgingMethods } from './api/judging';
import { vehicleHistoryMethods } from './api/vehicleHistory';
import { discoveryBadgeClubMethods } from './api/discoveryBadges';
import { homeMethods } from './api/home';
import { sponsorshipMethods } from './api/sponsorship';
import { favoritesMethods } from './api/favorites';
import { buildExpansionMethods } from './api/buildExpansion';
import { communityPostsMethods } from './api/communityPosts';
import { paidEventsMethods } from './api/paidEvents';
import { accountPrivacyMethods } from './api/accountPrivacy';
import { limitedDesignationMethods } from './api/limitedDesignations';
import { clientConfigMethods } from './api/clientConfig';
import { featureFlagsCatalogMethods } from './api/featureFlagsCatalog';

export type ApiServiceType = ApiClient &
  typeof authMethods &
  typeof vehiclesMethods &
  typeof modificationsMethods &
  typeof imagesMethods &
  typeof performanceMethods &
  typeof searchMethods &
  typeof profileMethods &
  typeof importMethods &
  typeof adminMethods &
  typeof adminEmailMethods &
  typeof sharingMethods &
  typeof analyticsMethods &
  typeof eventsMethods &
  typeof judgingMethods &
  typeof vehicleHistoryMethods &
  typeof discoveryBadgeClubMethods &
  typeof homeMethods &
  typeof sponsorshipMethods &
  typeof favoritesMethods &
  typeof buildExpansionMethods &
  typeof communityPostsMethods &
  typeof paidEventsMethods &
  typeof accountPrivacyMethods &
  typeof limitedDesignationMethods &
  typeof clientConfigMethods &
  typeof featureFlagsCatalogMethods;

class ApiService extends ApiClient {
  constructor() {
    super();
    Object.assign(
      this,
      authMethods,
      vehiclesMethods,
      modificationsMethods,
      imagesMethods,
      performanceMethods,
      searchMethods,
      profileMethods,
      importMethods,
      adminMethods,
      adminEmailMethods,
      sharingMethods,
      analyticsMethods,
      eventsMethods,
      judgingMethods,
      vehicleHistoryMethods,
      discoveryBadgeClubMethods,
      homeMethods,
      sponsorshipMethods,
      favoritesMethods,
      buildExpansionMethods,
      communityPostsMethods,
      paidEventsMethods,
      accountPrivacyMethods,
      limitedDesignationMethods,
      clientConfigMethods,
      featureFlagsCatalogMethods
    );
  }
}

const apiService = new ApiService() as ApiServiceType;
export default apiService;
